<div *ngFor="let day of daysArray">
  <span>{{day.today}}
    <input checked=checked (click)="todayChecked=true"  type="checkbox">
  </span>
  <button (click)="todayCanTrue()">todayCanTrue</button>

</div>